export default (fn: () => void) => setTimeout(fn, 1);
